var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.125C19.9062 26.125 19.125 26.9844 19.125 28C19.125 29.0938 19.9844 29.875 21 29.875C22.0156 29.875 22.7969 29.0938 22.7969 28C22.875 26.9844 22.0156 26.125 21 26.125ZM21 23C21.625 23 22.1719 22.4531 22.1719 21.75V10.5C22.1719 9.875 21.5469 9.25 21 9.25C20.375 9.25 19.75 9.875 19.75 10.5V21.75C19.75 22.4531 20.2969 23 21 23ZM40.375 29.0938L24.75 2.6875C23.9688 1.35938 22.5625 0.578125 21 0.5C19.3594 0.5 17.9531 1.35938 17.1719 2.6875L1.54688 29.0938C0.765625 30.4219 0.765625 31.9844 1.54688 33.3125C2.32812 34.7188 3.73438 35.5 5.375 35.5H36.625C38.1875 35.5 39.5938 34.7188 40.375 33.3125C41.1562 31.9844 41.1562 30.4219 40.375 29.0938ZM38.1875 32.0625C37.875 32.6875 37.25 33 36.5469 33H5.375C4.67188 33 4.04688 32.6875 3.73438 32.0625C3.34375 31.5156 3.42188 30.8906 3.73438 30.3438L19.3594 3.9375C19.6719 3.39062 20.2969 3 21 3C21 3 20.9219 3 21 3C21.625 3.07812 22.25 3.39062 22.5625 3.9375L38.1875 30.3438C38.5 30.8906 38.5781 31.5156 38.1875 32.0625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleExclamation);
export default __webpack_public_path__ + "static/media/triangle-exclamation.b8eed7eae2b8d64ab17b1c49f7d0de00.svg";
export { ForwardRef as ReactComponent };